export default __webpack_public_path__ + "24084131f72b027fb7ce43077415db48.svg";